import {View} from 'MWC';
import tpl from '../templates/ScrollButton';

export default class extends View {
    state = {
        isShown: false
    };

    template = tpl;

    scrollToTop = () => this.setState({isShown: !this.state.isShown});

    static displayName = 'ScrollButton';
}
